<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" v-text="icon" :class="iconStyles" />
    </template>
    <span v-html="allMessages" />
  </v-tooltip>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'AppWarning',
  props: {
    warningMessages: {
      type: Array,
      default: () => [],
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    icon() {
      if (this.hasWarning || this.hasError) {
        return 'warning'
      } else {
        return ''
      }
    },
    iconStyles(item) {
      return [
        css`
          width: 30px;
        `,
        {
          'yellow--text text--darken-2': item.hasWarning && !this.hasError,
          'red--text text--darken-2': item.hasError,
        },
      ]
    },
    allMessages() {
      return this.warningMessages.concat(this.errorMessages).join('<br />')
    },
    hasWarning() {
      return this.warningMessages.length > 0
    },
    hasError() {
      return this.errorMessages.length > 0
    },
  },
}
</script>
